/**
 * @generated SignedSource<<fc1a2ea7371fded4307d26e9b6ad7f5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type ExternalConversationType = "CHANNEL" | "DIRECT_MESSAGE" | "GROUP_DIRECT_MESSAGE" | "GROUP_MEETING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type threadTitle_AtlassianSearchPage$data = {
  readonly containerName: string | null | undefined;
  readonly entity: {
    readonly container?: {
      readonly displayName?: string | null | undefined;
      readonly members?: ReadonlyArray<{
        readonly thirdPartyUser: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly type?: ExternalConversationType | null | undefined;
    } | null | undefined;
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly initialContributors: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
  }> | null | undefined;
  readonly integrationId: string | null | undefined;
  readonly linkedEntities: ReadonlyArray<{
    readonly entity: {
      readonly container?: {
        readonly members?: ReadonlyArray<{
          readonly thirdPartyUser: {
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly type?: ExternalConversationType | null | undefined;
      } | null | undefined;
      readonly createdBy?: {
        readonly thirdPartyUser: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly initialContributors: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    }> | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "threadTitle_AtlassianSearchPage";
};
export type threadTitle_AtlassianSearchPage$key = {
  readonly " $data"?: threadTitle_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"threadTitle_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  }
],
v1 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "initialContributors",
  "plural": true,
  "selections": (v0/*: any*/)
},
v2 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": (v0/*: any*/)
  }
],
v3 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v2/*: any*/)
},
v4 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v2/*: any*/)
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "threadTitle_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "containerName"
    },
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    (v1/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    },
                    (v4/*: any*/),
                    (v5/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "container",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v4/*: any*/),
                        (v5/*: any*/)
                      ],
                      "type": "ExternalConversation"
                    }
                  ]
                }
              ],
              "type": "ExternalMessage"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "db6ce7181376179e452d32bececf3fe6";

export default node;
